/**
 * Mounts the shared application providers and a single persistent notification host.
 * Feature pages retain business state; notification code loads independently of startup.
 */
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.tsx';
import './base.css';
import './responsive.css';
import { queryClient } from './lib/query.ts';

const Notifications = lazy(() => import('./components/Notifications.tsx'));

const root = document.getElementById('root');
if (!root) throw new Error('缺少 #root');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Suspense fallback={null}><Notifications /></Suspense>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
